'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _consts = require('@wix/photography-client-lib/dist/src/utils/consts');

var _consts2 = _interopRequireDefault(_consts);

var _windowWrapper = require('@wix/photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

var _fullscreen = require('@wix/photography-client-lib/dist/src/versioning/features/fullscreen');

var _galleryItem = require('@wix/pro-gallery-renderer/dist/src/components/item/galleryItem');

var _galleryItem2 = _interopRequireDefault(_galleryItem);

var _swipper = require('./swipper.js');

var _swipper2 = _interopRequireDefault(_swipper);

var _bottomLink = require('./bottomLink.js');

var _bottomLink2 = _interopRequireDefault(_bottomLink);

var _fullscreenSlider = require('./fullscreenSlider.js');

var _fullscreenSlider2 = _interopRequireDefault(_fullscreenSlider);

var _fullscreenDesktopNavbar = require('./fullscreenDesktopNavbar.js');

var _fullscreenDesktopNavbar2 = _interopRequireDefault(_fullscreenDesktopNavbar);

var _mobileBar = require('./mobileBar');

var _mobileBar2 = _interopRequireDefault(_mobileBar);

var _fullscreenSidebar = require('./fullscreenSidebar.js');

var _fullscreenSidebar2 = _interopRequireDefault(_fullscreenSidebar);

var _fullscreenShareScreen = require('./fullscreenShareScreen.js');

var _fullscreenShareScreen2 = _interopRequireDefault(_fullscreenShareScreen);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_utils.utils.fixViewport('Fullscreen');

function defaultNavigateAction(url) {
  _windowWrapper2.default.open(url);
}

var ProFullscreen = function (_React$Component) {
  (0, _inherits3.default)(ProFullscreen, _React$Component);

  function ProFullscreen(props) {
    (0, _classCallCheck3.default)(this, ProFullscreen);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProFullscreen.__proto__ || (0, _getPrototypeOf2.default)(ProFullscreen)).call(this, props));

    _this.handleMouseMove = _lodash2.default.throttle(function () {
      (0, _jquery2.default)('.fullscreen-icon').show().css('opacity', '1');
      (0, _jquery2.default)('body').removeClass('no-cursor');
      clearTimeout(_this.mouseMovedTimeout);

      if (_this.state.isExpandedView) {
        if (!_this.getItem().isDemo && !_utils.utils.isTouch()) {
          _this.mouseMovedTimeout = setTimeout(function () {
            (0, _jquery2.default)('body').addClass('no-cursor');
            (0, _jquery2.default)('.fullscreen-icon').css('opacity', '0');
          }, 3000);
        }
      }
    }, 100).bind(_this);
    _this.handleKeypress = _lodash2.default.throttle(function (e) {

      switch (e.keyCode || e.charCode) {
        case 38: //up
        case 37: //left
        case 33:
          //page up
          e.preventDefault();
          _this.nextSlide(-1);
          return false;
        case 39: //right
        case 40: //down
        case 34:
          //page down
          e.preventDefault();
          _this.nextSlide(1);
          return false;
        case 27:
          //esc
          e.preventDefault();
          _this.handleMouseMove();
          _this.closeExpandBrowser();
          return false;
      }
      _this.handleMouseMove();
      return true; //continue handling the original keyboard event
    }, 100).bind(_this);

    _this.onFullscreenChange = function () {
      // exit fullscreen
      if (!_windowWrapper2.default.document.fullscreenElement && !_windowWrapper2.default.document.webkitIsFullScreen && !_windowWrapper2.default.document.mozFullScreen && !_windowWrapper2.default.document.msFullscreenElement) {
        if (_this.state.isExpandedView) {
          _this.setState({
            isExpandedView: false,
            showInfo: _this.props.styles.defaultShowInfoExpand && _this.state.current.hasInfo,
            infoToggledByUser: false
          });
        }
      }
    };

    _this.onOrientationChange = function () {
      _this.isLandscape = _this.isLandscapeInMobile();
      _this.setState({
        isMobileZoom: _this.isLandscape,
        isExpandedView: _this.isLandscape
      });
    };

    _this.toggleMobileBars = _this.toggleMobileBars.bind(_this);
    _this.fadeToNextSlide = _this.fadeToNextSlide.bind(_this);
    _this.toggleZoomMode = _this.toggleZoomMode.bind(_this);
    _this.getItemsToDisplay = _this.getItemsToDisplay.bind(_this);
    _this.handleAddToCartRequest = _this.handleAddToCartRequest.bind(_this);

    _this.nextSlide = _this.nextSlide.bind(_this);
    _this.toggleShopFrame = _this.toggleShopFrame.bind(_this);
    _this.toggleMobileShopFrame = _this.toggleMobileShopFrame.bind(_this);
    _this.toggleShareScreen = _this.toggleShareScreen.bind(_this);
    _this.toggleInfo = _this.toggleInfo.bind(_this);
    _this.expandBrowser = _this.expandBrowser.bind(_this);
    _this.closeExpandBrowser = _this.closeExpandBrowser.bind(_this);

    _this.extraImages = _utils.utils.isMobile() ? 2 : 5; //number of images to preload on each side of the fullscreen

    _this.actions = (0, _extends3.default)({
      toggleInfo: _this.toggleInfo,
      toggleMobileShopFrame: _this.toggleMobileShopFrame,
      toggleShareScreen: _this.toggleShareScreen,
      toggleShopFrame: _this.toggleShopFrame,
      next: _this.nextSlide,
      expandBrowser: _this.expandBrowser,
      closeExpandBrowser: _this.closeExpandBrowser
    }, props.actions);

    //TODO: replace with css modules
    (0, _utils.replaceWindowElement)({
      type: 'style',
      id: 'inlineDynamicFullscreenWixParamsCss',
      attributes: { type: 'text/css' },
      innerHTML: (0, _utils.createFullscreenStyle)(props.styles),
      parentElement: _windowWrapper2.default.document.getElementsByTagName('head')[0]
    });

    if (props.styles.googleFontsCssUrl) {
      (0, _utils.replaceWindowElement)({
        type: 'style',
        id: 'inlineDynamicFullscreenWixParamsFont',
        attributes: { type: 'text/css', rel: 'stylesheet', href: props.styles.googleFontsCssUrl },
        parentElement: _windowWrapper2.default.document.getElementsByTagName('head')[0]
      });
    }

    _this.state = {
      isExpandedView: props.styles.initialExpandedView || false,
      isMobileZoom: false,
      animating: false,
      pricingData: null,
      providerView: null,
      showMobileShopFrame: false,
      showShopFrame: _utils.utils.isStoreGallery(),
      showShareScreen: false,
      showShare: false
    };

    _this.state.window = _this.getWindowState();
    _this.state.current = _this.getCurrentItemState(props.initialIdx);
    _this.state.showInfo = props.styles && !props.styles.initialExpandedView && props.styles.defaultShowInfoExpand && _this.state.current.hasInfo;
    _this.isLandscape = _this.isLandscapeInMobile();

    ['onNextSlide', 'onCheckout', 'toggleBrowserFullscreen', 'onOpen'].forEach(function (action) {
      if (!_lodash2.default.isFunction(props.actions[action])) {
        _this.actions[action] = _lodash2.default.noop;
      }
    });

    if (!_lodash2.default.isFunction(props.actions.navigate)) {
      _this.actions.navigate = defaultNavigateAction;
    }
    return _this;
  }

  (0, _createClass3.default)(ProFullscreen, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearEvents();
      try {
        if (typeof this.props.unblockScroll === 'function') {
          this.props.unblockScroll();
        }
      } catch (e) {
        console.error('Fail to unblock scroll in expand mode', e);
      }
    }
  }, {
    key: 'isLandscapeInMobile',
    value: function isLandscapeInMobile() {
      return _utils.utils.isMobile() && (_windowWrapper2.default.orientation === 90 || _windowWrapper2.default.orientation === -90);
    }
  }, {
    key: 'initEvents',
    value: function initEvents() {
      _windowWrapper2.default.addEventListener('keydown', this.handleKeypress);
      _windowWrapper2.default.addEventListener('fullscreenchange', this.onFullscreenChange);
      _windowWrapper2.default.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
      _windowWrapper2.default.addEventListener('mozfullscreenchange', this.onFullscreenChange);
      _windowWrapper2.default.addEventListener('MSFullscreenChange', this.onFullscreenChange);
      _windowWrapper2.default.addEventListener('mousemove', this.handleMouseMove);
      _windowWrapper2.default.addEventListener('mousedown', this.handleMouseMove);
      _windowWrapper2.default.addEventListener('orientationchange', this.onOrientationChange);
    }
  }, {
    key: 'clearEvents',
    value: function clearEvents() {
      _windowWrapper2.default.removeEventListener('keydown', this.handleKeypress);
      _windowWrapper2.default.removeEventListener('fullscreenchange', this.onFullscreenChange);
      _windowWrapper2.default.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
      _windowWrapper2.default.removeEventListener('mozfullscreenchange', this.onFullscreenChange);
      _windowWrapper2.default.removeEventListener('MSFullscreenChange', this.onFullscreenChange);
      _windowWrapper2.default.removeEventListener('mousemove', this.handleMouseMove);
      _windowWrapper2.default.removeEventListener('mousedown', this.handleMouseMove);
      _windowWrapper2.default.removeEventListener('orientationchange', this.onOrientationChange);
    }

    //WARNING! To be deprecated in React v17. Use new lifecycle static getDerivedStateFromProps instead.

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!_lodash2.default.isEqual(this.props.styles, nextProps.styles) || !_lodash2.default.isEqual(this.props.container, nextProps.container)) {
        (0, _utils.replaceWindowElement)({
          type: 'style',
          id: 'inlineDynamicFullscreenWixParamsCss',
          attributes: { type: 'text/css' },
          innerHTML: (0, _utils.createFullscreenStyle)(nextProps.styles),
          parentElement: _windowWrapper2.default.document.getElementsByTagName('head')[0]
        });

        if (nextProps.styles.googleFontsCssUrl) {
          (0, _utils.replaceWindowElement)({
            type: 'style',
            id: 'inlineDynamicFullscreenWixParamsFont',
            attributes: { type: 'text/css', rel: 'stylesheet', href: nextProps.styles.googleFontsCssUrl },
            parentElement: _windowWrapper2.default.document.getElementsByTagName('head')[0]
          });
        }

        this.setState({
          showInfo: !this.state.isExpandedView && this.state.current.hasInfo && (nextProps.styles.defaultShowInfoExpand || this.state.infoToggledByUser),
          window: this.getWindowState()
        });
      }
    }
  }, {
    key: 'getCurrentItemState',
    value: function getCurrentItemState(idx) {
      if (_lodash2.default.isUndefined(idx)) {
        idx = this.state.current.idx || 0;
      }
      return {
        idx: idx,
        item: this.getItem(idx),
        hasInfo: this.hasInfo(idx),
        pos: this.getItemsDisplayRange()
      };
    }
  }, {
    key: 'shouldShowInfo',
    value: function shouldShowInfo() {
      if (!this.state && this.props.styles.initialExpandedView) {
        return false;
      } else if (this.state && this.state.isExpandedView) {
        return false;
      } else if (_utils.utils.isStoreGallery() && !_utils.utils.isMobile()) {
        return true;
      } else if (this.state) {
        return this.state.showInfo;
      } else {
        return this.props.styles.defaultShowInfoExpand && !_utils.utils.isSmallScreen();
      }
    }
  }, {
    key: 'windowSize',
    value: function windowSize() {
      var isMobile = _utils.utils.isMobile();
      var dim = {
        width: Math.round(this.props.container.width / _utils.utils.getViewportScaleRatio()),
        height: Math.round(this.props.container.height / _utils.utils.getViewportScaleRatio())
      };

      var mobilePadding = _fullscreen.fullscreenVersionManager.useFullScreenMobilePadding() && isMobile ? _consts2.default.dimensions.MOBILE_PADDING : _consts2.default.dimensions.NO_PADDING;

      if (this.shouldShowInfo()) {
        return {
          // Without Side Bar width which is 30 percent of the window
          width: dim.width * 70 / 100,
          height: dim.height - mobilePadding
        };
      } else if (mobilePadding !== 0 && !this.isLandscape) {
        return {
          width: dim.width,
          height: dim.height - mobilePadding
        };
      } else {
        return dim;
      }
    }
  }, {
    key: 'getWindowScale',
    value: function getWindowScale() {
      var _this2 = this;

      var scale = {};
      if (this.state.isExpandedView || _utils.utils.isSmallScreen()) {
        scale = {
          horizontal: 1,
          vertical: 1
        };
      } else {
        var w = this.windowSize();
        scale = {
          horizontal: (w.width - 100 * 2) / w.width,
          vertical: (w.height - 100 * 2) / w.height
        };
      }
      scale.min = function (item) {
        if (_this2.state.isExpandedView || _utils.utils.isSmallScreen()) {
          return 1;
        } else {
          var _w = _this2.windowSize();
          var horizontal = (_w.width - 100 * 2) / item.width;
          var vertical = (_w.height - 100 * 2) / item.height;
          return Math.min(horizontal, vertical);
        }
      };
      return scale;
    }
  }, {
    key: 'getWindowState',
    value: function getWindowState() {
      return {
        size: this.windowSize(),
        expanded: this.state.isExpandedView,
        scale: this.getWindowScale()
      };
    }
  }, {
    key: 'hasInfo',
    value: function hasInfo(idx) {
      var curItem = void 0;
      if (!_lodash2.default.isUndefined(idx)) {
        curItem = this.getItem(idx);
      } else if (_lodash2.default.isUndefined(this.state.current)) {
        return false;
      } else {
        curItem = this.getItem(_lodash2.default.get(this, 'state.current.idx') || 0);
      }
      var hasInfo = _utils.utils.getTitleOrFilename(curItem.title, curItem.fileName) && this.props.styles.allowTitleExpand || curItem.description && this.props.styles.allowDescriptionExpand || !_lodash2.default.isUndefined(curItem.link.data);
      return hasInfo;
    }
  }, {
    key: 'getItem',
    value: function getItem(idx) {
      var emptyItem = function emptyItem() {
        return new _galleryItem2.default({
          dto: {
            itemId: '77551414-3539-47a8-a78e-df4d4e99009c',
            mediaUrl: 'dfcb76e4ef454dab8990a6d7f97bd8d8.jpg',
            metaData: {
              height: 3744,
              width: 3744
            }
          }
        });
      };
      if (!this.state) {
        return emptyItem();
      } else if (!_lodash2.default.isUndefined(idx) && _lodash2.default.isArray(this.props.items)) {
        return this.getOrCreateGalleryItem(idx) || emptyItem();
      } else if (_lodash2.default.get(this, 'state.current.item.id')) {
        return this.state.current.item;
      } else if (_lodash2.default.get(this, 'state.current.idx')) {
        return this.getOrCreateGalleryItem(_lodash2.default.get(this, 'state.current.idx'));
      } else if (_lodash2.default.get(this, 'prerenderedItem.id')) {
        return this.prerenderedItem;
      } else {
        return emptyItem();
      }
    }
  }, {
    key: 'getNextitem',
    value: function getNextitem(idx, direction) {
      var loop = this.props.styles.fullscreenLoop;
      var numOfitems = this.props.items.length;
      var next = idx + direction;
      if (next < 0) {
        return idx;
      } else if (next === numOfitems) {
        return loop ? 0 : idx;
      } else {
        return next;
      }
    }
  }, {
    key: 'getItemsDisplayRange',
    value: function getItemsDisplayRange() {
      var range = _utils.utils.isTouch() ? 2 : 5;
      if (!this.state) {
        return range;
      }
      var numOfitems = this.props.items.length - 1;
      if (numOfitems > 0 & this.props.styles.fullscreenLoop) {
        return Math.min(range, Math.floor(numOfitems / 2));
      } else {
        return Math.min(range, numOfitems);
      }
    }
  }, {
    key: 'getOrCreateGalleryItem',
    value: function getOrCreateGalleryItem(itemIdx) {

      //calc itemParams and clear cache if one of them had changed
      var itemParams = {
        windowSize: this.windowSize(),
        styleParams: this.props.styles
      };
      var stringifiedItemParams = (0, _stringify2.default)(itemParams);
      var shouldClearGalleryItems = stringifiedItemParams !== this.lastItemParams;
      if (shouldClearGalleryItems) {
        this.galleryItems = [];
        this.lastItemParams = stringifiedItemParams;
      }

      if (!this.galleryItems[itemIdx]) {
        var item = this.props.items[itemIdx];
        this.galleryItems[itemIdx] = item ? (0, _utils.prepareFullscreenItem)((0, _extends3.default)({
          item: item,
          itemIdx: itemIdx,
          scale: this.getWindowScale(),
          isExpandedView: this.state.isExpandedView,
          isMobileZoom: this.state.isMobileZoom,
          watermark: this.props.watermark
        }, itemParams)) : undefined;
      }

      return this.galleryItems[itemIdx];
    }
  }, {
    key: 'getMoreItemsIfNeeded',
    value: function getMoreItemsIfNeeded(nextIdx) {
      if (this.props.totalItemsCount > this.props.items.length && nextIdx > this.props.items.length - this.extraImages) {
        var itemsLength = this.props.items.length;
        this.actions.getMoreItems(itemsLength);
      }
    }
  }, {
    key: 'getItemsToDisplay',
    value: function getItemsToDisplay() {
      var items = this.props.items;
      var idx = this.state.current.idx;

      var range = this.getItemsDisplayRange();
      var startIdx = idx - range;
      var endIdx = idx + range;

      //create a fixed size items array (size = range * 2 + 1)
      var itemsToDisplay = [];
      var numOfitems = items.length;
      var itemIdx = void 0;
      for (var i = startIdx; i <= endIdx; i++) {
        if (this.props.styles.fullscreenLoop) {
          itemIdx = i % numOfitems;
        } else {
          itemIdx = i;
        }

        itemsToDisplay.push(this.getItem(itemIdx));
      }
      return itemsToDisplay;
    }
  }, {
    key: 'closeExpandBrowser',
    value: function closeExpandBrowser() {
      var _this3 = this;

      if (this.state.isExpandedView) {
        this.setState({
          isExpandedView: false,
          showInfo: this.props.styles.defaultShowInfoExpand && this.state.current.hasInfo,
          infoToggledByUser: false
        }, function () {
          return _this3.actions.toggleBrowserFullscreen();
        });
      } else {
        this.actions.close(this.state.current.idx);
      }
    }
  }, {
    key: 'expandBrowser',
    value: function expandBrowser() {
      var _this4 = this;

      this.setState({
        isExpandedView: true,
        showInfo: false,
        infoToggledByUser: false
      }, function () {
        return _this4.actions.toggleBrowserFullscreen();
      });
    }
  }, {
    key: 'nextSlide',
    value: function nextSlide(direction, nextIdx, callback) {
      var _this5 = this;

      //this method should be called AFTER the animation is finished!

      if (!_lodash2.default.isFunction(callback)) callback = _lodash2.default.noop;

      //disable circling photos
      nextIdx = _lodash2.default.isUndefined(nextIdx) || _lodash2.default.isNull(nextIdx) ? this.getNextitem(Number(this.state.current.idx), direction) : nextIdx;
      if (nextIdx === this.state.current.idx) {
        callback();
        return;
      }

      if (_lodash2.default.isUndefined(nextIdx)) {
        callback();
        this.closeFullscreen();
      } else {
        var currentItem = this.getCurrentItemState(nextIdx);
        this.setState({
          current: currentItem,
          showInfo: !this.state.isExpandedView && currentItem.hasInfo && (this.props.styles.defaultShowInfoExpand || this.state.infoToggledByUser)
        }, function () {
          _this5.getMoreItemsIfNeeded(nextIdx);
          _this5.actions.onNextSlide(nextIdx);
          callback();
        });
      }
    }
  }, {
    key: 'toggleInfo',
    value: function toggleInfo(forceVal) {
      if (this.state.isExpandedView) {
        this.setState({ showInfo: false });
      } else {
        var showInfo = _lodash2.default.isUndefined(forceVal) ? !this.state.showInfo : forceVal;
        _utils.utils.setStateAndLog(this, 'toggleInfo', { showInfo: showInfo });
        this.setState({ infoToggledByUser: showInfo });
      }
    }
  }, {
    key: 'toggleShopFrame',
    value: function toggleShopFrame() {
      this.setState({
        showShopFrame: !this.state.showShopFrame
      });
    }
  }, {
    key: 'toggleMobileShopFrame',
    value: function toggleMobileShopFrame() {
      this.setState({
        showMobileShopFrame: !this.state.showMobileShopFrame
      });
    }
  }, {
    key: 'toggleShareScreen',
    value: function toggleShareScreen() {
      this.setState({
        showShareScreen: !this.state.showShareScreen
      });
    }

    //--------------------------------------------| UI Actions |-------------------------------------------//

  }, {
    key: 'fadeToNextSlide',
    value: function fadeToNextSlide(direction) {
      var _this6 = this;

      if (direction !== 0 && !this.state.animating) {
        _utils.utils.setStateAndLog(this, 'fadeToNextSlide animation start', {
          animating: true,
          direction: direction
        }, function () {
          setTimeout(function () {
            _this6.actions.next(direction); //triggers react after the animation is complete
            _this6.fixTransformForApple();
            _utils.utils.setStateAndLog(_this6, 'fadeToNextSlide animation complete', {
              animating: false,
              direction: 0
            }, _this6.fixTransformForApple);
          }, 400);
        });
      }
    }
  }, {
    key: 'toggleMobileBars',
    value: function toggleMobileBars(forceValueOrEvent) {
      if (_fullscreen.fullscreenVersionManager.useFullscreenNewMobileLayout()) {
        return;
      }

      if (forceValueOrEvent === false) {
        (0, _jquery2.default)('.fullscreen-mobile-bar').addClass('pro-fullscreen-hidden');
      } else if (forceValueOrEvent === true) {
        (0, _jquery2.default)('.fullscreen-mobile-bar').removeClass('pro-fullscreen-hidden');
      } else {
        var elem = (0, _jquery2.default)(forceValueOrEvent.target);
        if (!(elem.children('video').length || elem.is('video') || elem.is('i') || elem.is('a') || elem.is('button'))) {
          // do not toggle bars if clicking a video
          (0, _jquery2.default)('.fullscreen-mobile-bar').toggleClass('pro-fullscreen-hidden');
        }
      }
    }
  }, {
    key: 'toggleZoomMode',
    value: function toggleZoomMode(valueOrEvent) {
      if (_lodash2.default.isBoolean(valueOrEvent)) {
        if (this.isLandscape) {
          this.actions.close(this.state.current.idx);
        } else {
          this.setState({
            isMobileZoom: valueOrEvent
          });
        }
      } else {
        var tapTargetClass = _lodash2.default.get(valueOrEvent, 'target.className') || '';
        if (typeof tapTargetClass === 'string' || tapTargetClass instanceof String) {
          if (tapTargetClass.indexOf('fullscreen-item') >= 0 || tapTargetClass.indexOf('fullscreen-preload') >= 0) {
            //make sure that the tap is on the image / preload
            this.setState({
              // TURBO: use prevState func
              isMobileZoom: !this.state.isMobileZoom
            });
          }
        } else {
          // console.log('Not Toggling Zoom Mode', (_.get(tapEvent, 'target.className') || '').indexOf('fullscreen-item'), (_.get(tapEvent, 'target.className')), tapEvent);
        }
      }
    }

    //-----------------------------------------| DOM Manipulation |----------------------------------------//

  }, {
    key: 'fixLinkLineHeight',
    value: function fixLinkLineHeight() {
      var curItem = this.state.current.item;
      if (curItem.linkUrl && curItem.linkText) {
        //patch to limit link lines to 2

        try {
          var elem = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
          if (!elem) return;
          var link = elem.find('.fullscreen-side-bar-exif.pro-fullscreen-link');
          if (link.length !== 1) {
            return;
          }
          var lineHeight = parseInt(link.css('line-height'));
          var numOfLines = 2;
          link.height(numOfLines * lineHeight);
          link.css({ '-webkit-line-clamp': numOfLines + '' });
        } catch (e) {
          return;
        }
      }
    }
  }, {
    key: 'fixTransformForApple',
    value: function fixTransformForApple() {
      if (_utils.utils.isiOS()) {
        (0, _jquery2.default)('.pro-fullscreen-swipe-wrap .pro-fullscreen-slide').css('will-change', 'transform');
      } else if (_utils.utils.browserIs('safari')) {
        var transform = 'translate3d(0, 0, 0)';
        var duration = '0ms';

        (0, _jquery2.default)('.pro-fullscreen-swipe-wrap .pro-fullscreen-slide').css('will-change', 'transform').css('transform', transform).css('-webkit-transform', transform).css('-moz-transform', transform).css('-ms-transform', transform).css('-o-transform', transform).css('transition-duration', duration).css('-webkit-transition-duration', duration).css('-moz-transition-duration', duration).css('-ms-transition-duration', duration).css('-o-transition-duration', duration);
      }
    }
  }, {
    key: 'hasContainerChanged',
    value: function hasContainerChanged(container, prevContainer) {
      return container.width !== prevContainer.width || container.height !== prevContainer.height;
    }

    //------------------------------------------| React methods |------------------------------------------//

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_utils.utils.isTouch()) {
        this.swipper = new _swipper2.default({
          container: this.props.container,
          onTap: this.toggleZoomMode,
          allowSwipe: true,
          allowPinch: !_fullscreen.fullscreenVersionManager.useFullscreenNewMobileLayout() || this.state.isMobileZoom && !_lodash2.default.get(this, 'props.current.item.isVideo'),
          allowScroll: !this.state.isMobileZoom,
          mobileSwipeAnimation: this.props.styles.mobileSwipeAnimation
        }, this.actions.next);
        this.swipper.update();
      }
      this.isLandscape = this.isLandscapeInMobile();
      if (this.isLandscape) {
        this.setState({
          isMobileZoom: true,
          isExpandedView: true
        });
      }
      this.initEvents();
      this.handleMouseMove(); //show the icons (that will show on mouse move) on startup
      if (typeof this.actions.onOpen === 'function') {
        this.actions.onOpen();
      }

      if (typeof this.props.blockScroll === 'function' && typeof this.props.unblockScroll === 'function') {
        this.props.blockScroll();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      //check is this is really needed (do not do on every state change)
      this.fixLinkLineHeight();
      this.fixTransformForApple();

      var isMobileZoom = this.state.isMobileZoom;
      var mobileSwipeAnimation = this.props.styles.mobileSwipeAnimation;
      if (this.swipper) {
        this.swipper.enable();
        this.swipper.update();
        if (isMobileZoom !== prevState.isMobileZoom || mobileSwipeAnimation !== prevProps.styles.mobileSwipeAnimation || this.hasContainerChanged(this.props.container, prevProps.container)) {
          this.swipper.init({
            container: this.props.container,
            onTap: this.toggleZoomMode,
            allowSwipe: true,
            allowPinch: !!isMobileZoom,
            allowScroll: !isMobileZoom,
            mobileSwipeAnimation: mobileSwipeAnimation
          });
        }
        this.element && this.element.focus();
      }
    }
  }, {
    key: 'handleSetMobileData',
    value: function handleSetMobileData(type, data) {
      this.setState({ providerView: { type: type, data: data } });
    }
  }, {
    key: 'handleProviderAction',
    value: function handleProviderAction(type, data) {
      this.sidebar.postShopRequest(type, data);
    }
  }, {
    key: 'handleAddToCartRequest',
    value: function handleAddToCartRequest() {
      var sidebar = this.sidebar;
      if (sidebar && typeof sidebar.addToCartRequest === 'function') {
        this.sidebar.addToCartRequest();
      }
    }

    //____________________________________getters_____________________________________

  }, {
    key: 'getTopMobileBar',
    value: function getTopMobileBar(curItem) {
      return _react2.default.createElement(_mobileBar2.default, {
        id: curItem.id,
        idx: curItem.idx,
        itemId: this.state.current.item.id,
        current: this.state.current,
        styleParams: this.props.styles,
        actions: this.actions,
        galleryInfo: this.props.galleryInfo,
        showInfo: this.state.showInfo,
        isFirst: true,
        showShareScreen: this.state.showShareScreen,
        isPreview: this.props.isPreview
      });
    }
  }, {
    key: 'getBottomMobileBar',
    value: function getBottomMobileBar(curItem) {
      return _fullscreen.fullscreenVersionManager.useFullscreenNewMobileLayout() ? false : _react2.default.createElement(_mobileBar2.default, {
        id: curItem.id,
        idx: curItem.idx,
        itemId: this.state.current.item.id,
        current: this.state.current,
        styleParams: this.props.styles,
        actions: this.actions,
        showInfo: this.state.showInfo,
        isFirst: false,
        isPreview: this.props.isPreview
      });
    }
  }, {
    key: 'getSideBar',
    value: function getSideBar(cartItems, cartItemsCount) {
      var _this7 = this;

      return _react2.default.createElement(_fullscreenSidebar2.default, {
        ref: function ref(element) {
          return _this7.sidebar = element;
        },
        current: this.state.current,
        locale: this.props.locale,
        deviceType: this.props.deviceType,
        viewMode: this.props.viewMode,
        styleParams: this.props.styles,
        showInfo: this.state.showInfo,
        showShopFrame: this.state.showShopFrame,
        showMobileShopFrame: this.state.showMobileShopFrame,
        galleryInfo: this.props.galleryInfo,
        galleryId: this.props.galleryInfo && this.props.galleryInfo.galleryId ? this.props.galleryInfo.galleryId : '',
        actions: this.actions,
        window: this.getWindowState(),
        onSetMobileData: function onSetMobileData(type, data) {
          return _this7.handleSetMobileData(type, data);
        },
        providerView: this.state.providerView,
        onAddToCartRequest: !this.props.isPreview ? this.handleAddToCartRequest : _lodash2.default.noop,
        connectedProviders: this.props.galleryInfo.connectedProviders,
        cartItems: cartItems,
        cartItemsCount: cartItemsCount
      });
    }
  }, {
    key: 'getSmallScreenArrows',
    value: function getSmallScreenArrows(isNewLayout, isSmallScreen, isTouch, totalItems) {
      var _this8 = this;

      return !isNewLayout && !this.state.showInfo && isSmallScreen && !isTouch && !this.state.showMobileShopFrame ? [_react2.default.createElement('i', {
        className: 'fullscreen-prev pro-fullscreen-small-screen progallery-svg-font-icons-arrow_left ' + (this.state.current.idx <= 0 ? ' fullscreen-icon-disabled ' : ''),
        onClick: function onClick() {
          return _this8.fadeToNextSlide(-1);
        },
        key: 'small-screen-arrow-back'
      }), _react2.default.createElement('i', {
        className: 'fullscreen-next pro-fullscreen-small-screen progallery-svg-font-icons-arrow_right ' + (this.state.current.idx >= totalItems - 1 ? ' fullscreen-icon-disabled ' : ''),
        onClick: function onClick() {
          return _this8.fadeToNextSlide(1);
        },
        key: 'small-screen-arrow-next'
      })] : '';
    }
  }, {
    key: 'getBottomLinkContainer',
    value: function getBottomLinkContainer() {
      this.state.current.item.hasLink && this.props.styles.allowLinkExpand ? _react2.default.createElement(_bottomLink2.default, {
        current: this.state.current,
        actions: this.actions
      }) : null;
    }
  }, {
    key: 'getSlider',
    value: function getSlider(totalItems, cartItemsCount) {
      var _this9 = this;

      return _react2.default.createElement(_fullscreenSlider2.default, {
        isExpandedView: this.state.isExpandedView,
        items: this.getItemsToDisplay(),
        isLandscape: this.isLandscape,
        current: this.getCurrentItemState(this.state.current.idx),
        window: this.getWindowState(),
        styleParams: this.props.styles,
        animating: this.state.animating,
        direction: this.state.direction,
        totalItems: totalItems,
        isMobileZoom: this.state.isMobileZoom,
        showShopFrame: this.state.showShopFrame,
        showMobileShopFrame: this.state.showMobileShopFrame,
        showShareScreen: this.state.showShareScreen,
        providerView: this.state.providerView,
        galleryId: this.props.galleryInfo && this.props.galleryInfo.galleryId ? this.props.galleryInfo.galleryId : '',
        pricingData: this.state.pricingData,
        onAddToCartRequest: !this.props.isPreview ? this.handleAddToCartRequest : _lodash2.default.noop,
        onProviderAction: function onProviderAction(type, data) {
          return _this9.handleProviderAction(type, data);
        },
        cartItemsCount: cartItemsCount,
        actions: _lodash2.default.merge(this.actions, {
          toggleMobileBars: this.toggleMobileBars,
          fadeToNextSlide: this.fadeToNextSlide
        })
      });
    }
  }, {
    key: 'getDesktopNavbar',
    value: function getDesktopNavbar(curItem, totalItems) {
      return _react2.default.createElement(_fullscreenDesktopNavbar2.default, {
        id: curItem.id,
        idx: curItem.idx,
        itemId: curItem.id,
        totalItems: totalItems,
        current: this.state.current,
        window: this.getWindowState(),
        styleParams: this.props.styles,
        galleryInfo: this.props.galleryInfo,
        showInfo: this.state.showInfo,
        navigatedInto: this.props.navigatedInto,
        actions: _lodash2.default.merge(this.actions, {
          fadeToNextSlide: this.fadeToNextSlide
        }),
        isPreview: this.props.isPreview
      });
    }
  }, {
    key: 'getFullscreenShareScreen',
    value: function getFullscreenShareScreen(isNewLayout) {
      return isNewLayout && _utils.utils.isMobile() ? _react2.default.createElement(_fullscreenShareScreen2.default, {
        current: this.state.current,
        styleParams: this.props.styles,
        showShareScreen: this.state.showShareScreen,
        actions: this.actions
      }) : null;
    }
  }, {
    key: 'getCloseButton',
    value: function getCloseButton() {
      var _this10 = this;

      return _react2.default.createElement('button', {
        className: 'fullscreen-icon fullscreen-toggle-zoom progallery-svg-font-icons-close-x ',
        onClick: function onClick() {
          return _this10.toggleZoomMode(false);
        }
      });
    }
  }, {
    key: 'getFullscreenClasses',
    value: function getFullscreenClasses() {
      var version = _fullscreen.fullscreenVersionManager.getVersionFullscreenVersion();
      var versionClassName = version.toLowerCase();
      var expandedClassName = this.state.isExpandedView ? ' pro-fullscreen-expanded ' : '';
      var themeClassName = _utils.utils.parseGetParam('theme') === 'dark' ? ' fullscreen-dark' : ' fullscreen-bright';
      var accessibilityClassName = _utils.utils.isAccessibilityEnabled() ? ' pro-fullscreen-accessible ' : '';
      var mobileClassName = _utils.utils.isMobile() ? 'pro-fullscreen-mobile' : '';
      return 'fullscreen pro-fullscreen inline-styles pro-fullscreen-' + versionClassName + ' ' + expandedClassName + ' ' + themeClassName + ' ' + accessibilityClassName + ' ' + mobileClassName;
    }

    //________________________________________________________________________________

  }, {
    key: 'render',
    value: function render() {
      var _this11 = this;

      var cartItems = this.props.cartItems || [];
      var cartItemsCount = this.props.cartItemsCount || 0;
      var totalItems = this.props.items.length;
      var isNewLayout = _fullscreen.fullscreenVersionManager.useFullscreenNewMobileLayout();
      var isMobile = _utils.utils.isMobile();
      var isSmallScreen = _utils.utils.isSmallScreen();
      var isTouch = _utils.utils.isTouch();
      var curItem = this.state.current.item;

      if (_utils.utils.isVerbose()) {
        console.timeEnd('Time in React');
        console.log('Render FullscreenView', this.props, this.state);
      }

      var clickAction = _utils.utils.getMobileEnabledClick(this.toggleMobileBars);
      var isMobileZoom = this.state.isMobileZoom;


      return isMobile ? _react2.default.createElement(
        'div',
        (0, _extends3.default)({
          ref: function ref(_ref) {
            return _this11.element = _ref;
          }
        }, clickAction, {
          'data-hook': 'fullscreen-view',
          id: 'fullscreen-view',
          className: this.getFullscreenClasses()
        }),
        isMobileZoom ? null : this.getDesktopNavbar(curItem, totalItems),
        isMobileZoom ? null : this.getTopMobileBar(curItem),
        !isMobileZoom && _utils.utils.isStoreGallery() && this.getSideBar(cartItems, cartItemsCount),
        isMobileZoom && _fullscreen.fullscreenVersionManager.useFullscreenNewMobileLayout() ? this.getCloseButton() : null,
        this.getSlider(totalItems, cartItemsCount),
        this.getSmallScreenArrows(isNewLayout, isSmallScreen, isTouch, totalItems),
        isMobileZoom ? null : this.getFullscreenShareScreen(isNewLayout),
        _fullscreen.fullscreenVersionManager.useFullscreenNewMobileLayout() ? null : this.getBottomMobileBar(curItem)
      ) : _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, clickAction, {
          'data-hook': 'fullscreen-view',
          id: 'fullscreen-view',
          className: this.getFullscreenClasses()
        }),
        this.getDesktopNavbar(curItem, totalItems),
        this.getSideBar(cartItems, cartItemsCount),
        this.getBottomLinkContainer(),
        this.getSlider(totalItems, cartItemsCount),
        this.getSmallScreenArrows(isNewLayout, isSmallScreen, isTouch, totalItems)
      );
    }
  }]);
  return ProFullscreen;
}(_react2.default.Component);

ProFullscreen.propTypes = {
  actions: _propTypes2.default.shape({
    getMoreItems: _propTypes2.default.func.isRequired,
    close: _propTypes2.default.func.isRequired,
    navigate: _propTypes2.default.func,
    onOpen: _propTypes2.default.func,
    onNextSlide: _propTypes2.default.func,
    toggleBrowserFullscreen: _propTypes2.default.func
  }),
  items: _propTypes2.default.array,
  initialIdx: _propTypes2.default.number,
  styles: _propTypes2.default.object.isRequired,
  container: _propTypes2.default.shape({
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired
  }),
  locale: _propTypes2.default.string,
  deviceType: _propTypes2.default.string,
  isPreview: _propTypes2.default.bool
};

ProFullscreen.defaultProps = {
  items: [],
  initialIdx: 0,
  locale: 'en',
  deviceType: 'desktop',
  isPreview: false,
  galleryInfo: {
    connectedProviders: {}
  }
};

exports.default = ProFullscreen;